<script setup>
import ReservationsReviewPage from '@/pages/reservations-review.vue'
</script>

<template>
  <ReservationsReviewPage />
</template>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
  allowLoggedInOnly: true
  requiresRestaurantAdmin: true
</route>
